import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getNotifiactionInfo } from "common/components/NotificationsMenu/components/constants"
import { Badge } from "primereact/badge"

import "../style.scss"

const NotificationsItemIcon = ({ notification }: $TSMigrationFixMe) => {
  return (
    <div className='notifications-item-icon-container d-flex justify-content-center mr-3 my-auto'>
      <div className='notifications-item-icon-avatar d-flex justify-content-center'>
        <FontAwesomeIcon
          className={`notifications-item-icon ${
            notification.read ? "" : "notifications-item-icon-no-read"
          } m-auto`}
          icon={[
            // @ts-expect-error TS(2322): Type '"fa-light"' is not assignable to type 'IconP...
            "fa-light",
            // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'IconName'...
            getNotifiactionInfo(notification.type)?.icon || "paperclip",
          ]}
        />
      </div>
      {!notification.read && (
        <Badge className='notifications-item-icon-no-read-mark' />
      )}
    </div>
  )
}

export default NotificationsItemIcon
